export default __webpack_public_path__ + "static/media/Malvie.0f8111b1.ttf";